import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'replaceComa'})
export class ReplaceComa implements PipeTransform {
    transform(val: string, cantDecimales: number): string {
        if (val !== undefined && val !== null) {
            const n = val.toString().indexOf('.');
            const decimales = val.toString().substring(n + 1, val.length);
            if (n === -1) {
                val += '.';
                for (let i = 0; i < cantDecimales; i++) {
                    val += '0';
                }
                return val;
            } else {
                const cerosFaltantes = cantDecimales - decimales.length;
                for (let i = 0; i < cerosFaltantes; i++) {
                    val += '0';
                }
            }
            val = val.toString().replace(/[,]+/g, '&');
            val = val.toString().replace(/[.]+/g, ',');
            val = val.toString().replace(/[&]+/g, '.');
            return val;

        } else {
            return '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/replaceComa.pipe.ts